module.exports = __webpack_public_path__ + "img/6 - Riaan Nel.89c3e285.jpg";